export const getErrorMessage = (error: any) => {
  const responseData = error?.response?.data;
  const validationErrors = responseData?.validation_errors;

  if (responseData?.detail) {
    return responseData.detail;
  }

  if (validationErrors && Object.keys(validationErrors).length === 1 && typeof validationErrors.detail === "string") {
    return validationErrors.detail;
  }

  if (validationErrors) {
    return Object.entries(validationErrors)
      .map(([key, value]) => {
        if (typeof value === "object" && !Array.isArray(value)) {
          return Object.entries(value ?? {})
            .map(([nestedKey, messages]) => {
              return `${key.replaceAll("_", " ")} ${nestedKey}: ${
                Array.isArray(messages) ? messages.join(", ") : messages
              }`;
            })
            .join("; ");
        }
        return `${key.replaceAll("_", " ")}: ${Array.isArray(value) ? value.join(", ") : value}`;
      })
      .join("; ");
  }

  if (typeof responseData?.error === "string") {
    return responseData.error;
  }

  return "An error occurred";
};
